(
    function (skyward, $, undefined)
    {
        skyward.editablebrowse = skyward.editablebrowse || {};

        var init = function (selector)
        {
            $(selector + " .editablebrowse, " + selector + ".editablebrowse").each(function ()
            {
                var editableBrowse = $(this);
                var data = editableBrowse.data();

                //This will trigger a scroll of locked browseBody also, required as rows can't be selected in editable browses
                editableBrowse.find(".unlockedBrowseBody").scrollTop(0);

                data.editablebrowsedata = data.editablebrowsedata || [];

                var originalCustomSaveData = data.originalcustomsavedata || [];
                if (originalCustomSaveData && originalCustomSaveData.length > 0 && originalCustomSaveData != "")
                {
                    var inputs = {};
                    editableBrowse.find("[name]").each(function ()
                    {
                        inputs[this.name] = $(this);
                    });

                    $.each(originalCustomSaveData, function ()
                    {
                        var currentInput = inputs[this.Key];
                        if (!currentInput)
                        {
                            currentInput = { saveJson: true, name: this.Key, value: this.Value, data: {} };
                        }
                        else
                        {
                            skyward.controls.setValue(currentInput, this.Value, true);
                            currentInput.attr("data-original-value", skyward.controls.getValue(currentInput));
                        }
                        skyward.dataobjectviewer.updateCustomSaveData(currentInput, data.editablebrowsedata, true);
                    });
                    editableBrowse.data("originalCustomSaveData", "");
                    data.originalcustomsavedata = [];
                }

                editableBrowse.find("input, select, textarea").not(".browseSearchBox, .browseRowsPerPage").each(function ()
                {
                    var input = $(this);
                    input.on("change", function ()
                    {
                        skyward.dataobjectviewer.updateCustomSaveData(input, data.editablebrowsedata, true);
                        skyward.browseSeekInfo.save(skyward.browse.browseList[skyward.browse.getCurrentBrowseName()]);
                    });

                    // Add event to fire when checkbox is changed to reset percent field
                    if (input.data("selectpercent"))
                    {
                        input.on("change", function ()
                        {
                            if (input.is(":checkbox") && !input.is(":checked"))
                            {
                                skyward.controls.setValue(editableBrowse.find("#" + input.attr("data-selectPercent")), "");
                            }
                        });
                    }

                    // Add event to fire when percent field with this data attribute is changed for browse label
                    if (input.data("includefieldforsectionheaderpercenttotal")) 
                    {
                        var calculatePercentageInSectionHeader = function ()
                        {
                            skyward.editablebrowse.calculateTotalPercentage(editableBrowse, editableBrowse.find(".sectionHeader__text"), "includefieldforsectionheaderpercenttotal", "true");
                        };

                        input.on("change", function ()
                        {
                            calculatePercentageInSectionHeader();
                        });

                        // Fire when DOM is loaded to calculate existing percentage if percenttotal control exist
                        $(function ()
                        {
                            calculatePercentageInSectionHeader();
                        });
                    }

                    // Add event to fire when percent field with this data attribute is changed for segmented row header
                    if (input.data("includefieldforsegmentedrowheaderpercenttotal"))
                    {
                        var fieldName = input.data("includefieldforsegmentedrowheaderpercenttotal");
                        var calculatePercentageInSegmentedRowHeader = function ()
                        {
                            // Add the field name to the class name too since you could have multiple segmented column that requires a running total
                            skyward.editablebrowse.calculateTotalPercentage(editableBrowse, editableBrowse.find('div .parentDataCell.segmentedRowHeaderTotalPercent.' + fieldName + ''), "includefieldforsegmentedrowheaderpercenttotal", fieldName);
                        };

                        input.on("change", function ()
                        {
                            calculatePercentageInSegmentedRowHeader();
                        });

                        // Fire when DOM is loaded to calculate existing percentage if percenttotal control exist
                        $(function ()
                        {
                            calculatePercentageInSegmentedRowHeader();
                        });
                    }
                });

                if (editableBrowse.hasClass("FilterDependency"))
                {
                    if (editableBrowse.data("dynamicfilterfield"))
                    {
                        var dependentFields = editableBrowse.data("dynamicfilterfield").split(",");

                        for (var i = 0; i < dependentFields.length; i++)
                        {
                            $(selector + " #" + dependentFields[i]).on("change", function ()
                            {
                                UpdateDependencyFilter(editableBrowse, $(this));
                            });
                        }
                    }
                }
                if (editableBrowse.is(":visible"))
                {
                    // Populate aria-labelledby attribute with the browse's title
                    editableBrowse.attr("aria-labelledby", editableBrowse.find(".sectionHeader__text").attr("id"));
                    resizeHeadersAndFootersForContent(editableBrowse);
                }
            });

            var UpdateDependencyFilter = function (browse, element)
            {
                var filterPostData = {};
                filterPostData[element.attr("id")] = skyward.controls.getValue(element);
                skyward.browse.updateDependency(browse.attr("id"), { dependencyPostData: filterPostData });
            };
        };

        var resizeHeadersAndFootersForContent = function (editableBrowse)
        {
            var containingBrowse = skyward.browse.getContainingBrowse(editableBrowse);
            if (!containingBrowse)
            {
                return;
            }
            // These are header table-cells' sole children
            let autosizeHeaders = containingBrowse.header.find(".js-browseHeader__cellContentContainer--autosize");
            if (autosizeHeaders.length > 0)
            {
                autosizeHeaders.removeClass(".js-browseHeader__cellContentContainer--autosize");

                if (containingBrowse.browse.find(".noRecordsInBrowse").length > 0)
                {
                    return;
                }

                let headerAndFooterResizeSizes = [];
                let cellResizeSizes = [];
                autosizeHeaders.each(function ()
                { 
                    let column = $(this).data("column");
                    let correspondingTotalFooterColumnDiv = containingBrowse.footer.find("div[data-column='" + CSS.escape(column) + "']"); 
                    let data = $(this).data();
                    let preferredWidth = data.preferredWidth;
                    let fitColumn = data.fitColumn;
                    let columnCells = containingBrowse.body.find(".browseRow .browseDataCell.column" + column + " > div");

                    let cellWidth = parseInt(getComputedStyle(columnCells[0]).width, 10);
                    // If the view has a width defined, it will be passed as data-preferred-width so we can measure the
                    // header's intrinsic width.
                    let headerWidth = typeof preferredWidth === "number"
                        ? preferredWidth
                        : parseInt(getComputedStyle(this).width, 10);
                    let width = Math.max(headerWidth, cellWidth);

                    // Don't allow resizing below the cell's width, unless the cell's viewpart supports it
                    let minWidth = fitColumn
                        ? null
                        : Math.max(cellWidth, skyward.browse.minColumnWidth);

                    // Changing widths can change how the table's width is distributed among other rows.  All columns must have widths
                    // defined to prevent discrepancies after we update them.
                    headerAndFooterResizeSizes.push({ width: width, minWidth: minWidth, header: $(this), footer: correspondingTotalFooterColumnDiv });
                    cellResizeSizes[column] = { width: width, fitColumn: fitColumn, cells: columnCells };
                });

                headerAndFooterResizeSizes.forEach(function (headerObj)
                {
                    let header = headerObj.header;
                    let footer = headerObj.footer;
                    header[0].style.width = headerObj.width + "px";
                    if (footer.length > 0)
                    {
                        footer[0].style.width = headerObj.width + "px";
                    }
                    if (headerObj.minWidth && header.is(".tdResizeDiv.ui-resizable"))
                    {
                        header.resizable("option", "minWidth", headerObj.minWidth);
                    }
                });

                cellResizeSizes.forEach(function (columnObj)
                {
                    // Tables are constrained to grid layout, and normally we would only have to set one row's width.
                    // However, any children with parent-relative widths, such as percentages, appear to assume the width
                    // the column would have had otherwise.
                    // This could be avoided by setting the parent td's width instead.
                    columnObj.cells.css("width", columnObj.width);
                    if (columnObj.fitColumn)
                    {
                        columnObj.cells.children().css("width", "100%");
                    }
                });
            }
        };

        skyward.editablebrowse.calculateTotalPercentage = function (browse, controlToUpdate, dataAttr, dataAttrValue)
        {
            // Find control of label to update
            if (controlToUpdate && controlToUpdate.get(0))
            {
                // Get the text of the label
                var originalText = controlToUpdate.html();
                // If none is found default it
                originalText = originalText || "Total";
                var endIndex = originalText.lastIndexOf("-");
                var newText = originalText;

                if (endIndex > -1)
                {
                    // Grab original label without percentage
                    newText = originalText.substring(0, endIndex - 1);
                }

                var total = 0;
                // Add up all input with data attribute
                browse.find("input[data-" + dataAttr + "='" + dataAttrValue + "']").each(function ()
                {
                    var value = parseFloat($(this).val());
                    if (value && !isNaN(value))
                    {
                        total += value;
                    }
                });

                total = new Number(total).toFixed(2);
                controlToUpdate.html(newText + " - " + total.toString() + "%");

            }
        };

        skyward.editablebrowse.getData = function (browse)
        {
            var editableData = skyward.editablebrowse.getEditableData(browse.id);
            var data =
            {
                editableData: editableData,
                renderFilter: $("#" + browse.id + "_filterButton").length > 0,
                renderView: $("#" + browse.id + "_viewButton").length > 0,
                disableDataLossWarning: browse.disableDataLossWarning,
                renderFooter: browse.renderFooter,
                readOnly: browse.readOnly,
                currentTaskInstanceId: browse.currentTaskInstanceId,
                readOnlyHash: browse.readOnlyHash,
                renderSortableHeader: browse.renderSortableHeader,
                renderHeaderSettings: browse.renderHeaderSettings,
                renderControls: browse.renderControls,
                dataObjectViewerID: browse.dataObjectViewerID
            };
            return data;
        };

        skyward.editablebrowse.getEditableData = function (browseId)
        {
            return JSON.stringify($('#' + browseId).data('editablebrowsedata'));
        };

        var currentlySelectingAll = false;
        skyward.editablebrowse.isCurrentlySelectingAll = function ()
        {
            return currentlySelectingAll;
        };
        skyward.editablebrowse.selectAllCheckBox = function (browseName, checkboxId, columnIndex)
        {
            currentlySelectingAll = true;
            var domBrowse = $('#' + browseName);
            var selectAllCheckBox = domBrowse.find("#" + checkboxId);

            if (selectAllCheckBox && selectAllCheckBox.get(0))
            {
                var isChecked = selectAllCheckBox.is(":checked");
                skyward.editablebrowse.selectAll = isChecked;

                domBrowse.find('td[data-column="' + columnIndex + '"]').each(function ()
                {
                    var cell = $(this);
                    var currentCheckBox = cell.find('input:checkbox');

                    if (currentCheckBox && currentCheckBox.get(0))
                    {
                        skyward.controls.changeCheckBoxWithSelectAll(currentCheckBox, isChecked);
                    }
                }).promise().done(function ()
                {
                    currentlySelectingAll = false;
                    //Since multiple select all boxes can be on one screen this will need to be changed be gotten from the checkbox
                    if (selectAllCheckBox.data("checkboxidformat") && selectAllCheckBox.data("checkboxidformat") != "")
                    {
                        var browse = skyward.browse.browseList[browseName];
                        if (!browse)
                        {
                            return null;
                        }

                        var browseData = skyward.browse.getRequiredBrowseData(browse, browse.data || domBrowse.data());
                        var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/SelectAll';

                        skyward.controls.disable(selectAllCheckBox);

                        const editableBrowseDataLoaded = $.Deferred();
                        skyward.workflow.addDisableNavigationPromise(editableBrowseDataLoaded);

                        return $.ajax(
                            {
                                url: url,
                                type: "POST",
                                dataType: "JSON",
                                complete: function ()
                                {
                                    skyward.controls.enable(selectAllCheckBox);
                                    editableBrowseDataLoaded.resolve();
                                },
                                success: function (data)
                                {
                                    var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                                    $.each(data.AllPrimaryKeys, function ()
                                    {
                                        var controlName = selectAllCheckBox.data("checkboxidformat").replace("{0}", this.toString());
                                        var currentInput = domBrowse.find("[name='" + controlName + "']");
                                        if (currentInput.length == 0)
                                        {
                                            currentInput = { saveJson: true, name: controlName, value: isChecked, data: {} };
                                        }
                                        skyward.dataobjectviewer.updateCustomSaveData(currentInput, editableBrowseData, true);
                                    });
                                },
                                data: browseData
                            });
                    }
                });
            }
            else
            {
                currentlySelectingAll = false;
            }
        };

        skyward.editablebrowse.disableRow = function (rowElement)
        {
            rowElement.find("input").each(function ()
            {
                var input = $(this);
                skyward.controls.setValue(input, input.data().originalValue);
                skyward.controls.disable(input);
            });

            rowElement.find(".browseDataCell").addClass("disabled");
        };

        skyward.editablebrowse.enableRow = function (rowElement)
        {
            rowElement.find("input").each(function ()
            {
                skyward.controls.enable($(this));
            });

            rowElement.find(".browseDataCell").removeClass("disabled");
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

        skyward.events.registerEvents("editablebrowse",
            {
                "autosizeHeadersAndFooters": resizeHeadersAndFootersForContent
            });

    }(window.skyward = window.skyward || {}, window.jQuery)
);
